import useFetchObjects from "../../api/useFetchObjects";

const useUser = () => {
  return useFetchObjects(
    ["user-profile"],
    "profile/",
    localStorage.getItem("token"),
    {
      refetchOnWindowFocus: false,
      enabled: localStorage.getItem("token") ? true : false,
    },
  );
};

export default useUser;
